import { render } from "./PartsAndService.vue?vue&type=template&id=3fd2cabe&scoped=true"
import script from "./PartsAndService.vue?vue&type=script&lang=js"
export * from "./PartsAndService.vue?vue&type=script&lang=js"

import "./PartsAndService.vue?vue&type=style&index=0&id=3fd2cabe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd2cabe"]])

export default __exports__